import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Form, Input, Select, Upload, Space, Spin, message, Drawer, Modal, DatePicker } from 'antd';
import { CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import "moment-timezone";
import moment from 'moment';
import ImgCrop from 'antd-img-crop';
import { Scrollbars } from 'react-custom-scrollbars';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from "react-router-dom";
import FeatherIcon from 'feather-icons-react';
import InitialData from './InitialData.json'
import { RelatedDocUpload } from './GlobalComponents/RelatedDocUpload'
import { setEditCall } from '../../../redux/CrmReduxCalls/EditNavCtrl';
import { AddUser } from '../style';
import { getStateData, getCityData, getCountryData, getAllUsersData, getLeadsourceData } from '../../../Api/Services/CommonApiService';
import { createContacts } from '../../../Api/Services/ContactApiService';
import { FetchAllAccount } from '../../../Api/Services/AccountApiService';
import { BasicFormWrapper } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import Heading from '../../../components/heading/heading';
import { getBaseURL } from '../../../Api/ApiConfig'
import AllCancelPopup from '../Popup/AllCancelPopup';
import { CancelIcon, SaveIcon } from '../../../components/Icons/Icons';
import { mobileOnChangeValidator, validateUrlField, nameOnChangeValidator, validateZipCode, validateEmailField, validateDescriptionField, validateAddressLine } from '../../../components/utilities/utilities';

const { Option } = Select;

function AddNew({ UrlId, FromPage, setCratePage, GetAll, dataForDeal, CallBackTrigger }) {
    const ApprovalMessage = "This record creation has triggered an approval process. The record will be available only after it has been reviewed and approved."
    const AutomationMessage = "Your action has triggered a business rule. Relevant validations, updates, or automated actions have been applied based on the configured logic."
    const dispatch = useDispatch();
    const urlPathname = window.location.pathname;
    const urlSearch = window.location.search;
    const combinedUrl = urlPathname + urlSearch;
    const [form] = Form.useForm();
    const [contactInitial, setContactInitial] = useState()
    const [contactsource, setContactSource] = useState([])
    const [edit, setEdit] = useState(false)
    const [displayData, setDisplayData] = useState()
    const [users, setUsers] = useState([])
    const [country, setCountry] = useState()
    const [allCountry, setAllCountry] = useState([])
    const [deleteOption, setDeleteOpen] = useState(false);
    const [state, setState] = useState()
    const [allState, setAllState] = useState([])
    const [city, setCity] = useState()
    const [allCity, setAllCity] = useState([])
    const [drawerPage, setDrawerPage] = useState()
    const [editField, setEditField] = useState(false)
    const [checked, setChecked] = useState(false)
    const [image, setImage] = useState()
    const [account, setAccount] = useState([])
    const [FILEList, setFileList] = useState([]);
    const [uiReady, setUiReady] = useState(false)
    const localData = useSelector((state) => state.localRedux);
    const ProfileData = localData.profile
    const profile = ProfileData
    const [cancelConfirmOpen, setCancelConfirmOpen] = useState(false)
    const [expectedClosureDate, setExpectedClosureDate] = useState(null)
    const [states, setStates] = useState({
        selectedRows: [],
        selectedRowKeys: [],
    });
    const loadingRef = useRef(false);
    const [doubleClick, setDoubleClick] = useState(false)
    const normalizeValue = (value) => {
        if (value === undefined || value === "") return null;
        return value;
    };
    // Deep equality check (order-insensitive for objects)
    const isEqual = (a, b) => {
        if (a === b) return true;

        if (typeof a !== typeof b) return false;

        if (Array.isArray(a) && Array.isArray(b)) {
            if (a.length !== b.length) return false;
            return a.every((item, i) => isEqual(item, b[i]));
        }

        if (typeof a === "object" && a !== null && b !== null) {
            const keysA = Object.keys(a);
            const keysB = Object.keys(b);
            if (keysA.length !== keysB.length) return false;

            return keysA.every(key => isEqual(a[key], b[key]));
        }

        return false;
    };
    const getChangedFields = (newData, oldData) => {
        return Object.keys(newData).reduce((acc, key) => {
            if (!(key in oldData) || !isEqual(newData[key], oldData[key])) {
                acc[key] = newData[key];
            }
            return acc;
        }, {});
    };
    async function UserDetailsApi() {
        try {
            const data = await getAllUsersData()
            const options = data.filter(item => item.department === "Sales").map((option, i) => (
                <Option value={option.userId} key={i} label={(
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className='Div_flex2'>
                            <div className='share_image' title={`${option.firstName} ${option.lastName} (${option.username})`} style={{ cursor: "default" }}>
                                {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                    < img src={option.profilePic} alt="profile" />
                                    :
                                    <span className="image_icon UserIcon">
                                        {option.firstName.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <span className='div-ellipsis'>{`${option.firstName} ${option.lastName}`}</span>
                            </div>
                        </div>
                    </div>
                )}>
                    <div className='UserList-dropdown' title={`${option.firstName} ${option.lastName} (${option.username})`}>
                        <div>
                            {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option.firstName.slice(0, 1).toUpperCase()}
                                </span>
                            }</div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                            <p style={{ margin: 0 }}>{option.username}</p>
                        </div>
                    </div>
                </Option>));
            setUsers(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    const getContactsource = async () => {
        try {
            const data = await getLeadsourceData()
            const options = data.map((option, i) => (
                <Option value={option.leadSourceId} key={i}>
                    {option.leadSourceName}
                </Option>));
            setContactSource(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function AccountApi() {
        try {
            const data = await FetchAllAccount()
            setAccount(data)
        } catch (error) {
            message.error(error)
        }
    }
    const FileUpload = {
        name: 'file',
        multiple: false,
        maxCount: 1,
        accept: 'image/*',
        action: `${getBaseURL()}/usermgmt/uploadFile`, // api for image upload
        onChange(info) {
            const { status } = info.file;
            if (status !== 'uploading') {
                // setState({ ...state, file: info.file, list: info.fileList });
            }
            if (status === 'done') {
                setImage(info.file.response.mediaUrl);// to set that image url
                setDeleteOpen(true)
                message.success(`${info.file.name} File upload successful`);
            } else if (status === 'error') {
                message.error(`${info.file.name} File upload failed`);
            }
        },
        listType: 'picture',
        showUploadList: false,
    };
    const handleDeleteImage = () => {
        setImage(null);
        setDeleteOpen(false);
    };
    const onFinishFailed = () => {
        message.error("Please fill out all required fields")
    }
    const getCountry = async () => {
        try {
            const response = await getCountryData()
            setAllCountry(response)
        }
        catch (error) {
            message.error(error)
        }
    }
    const handleCountryChange = async (value, option) => {
        setCountry(value);
        if (option.key) {
            try {
                const response = await getStateData(option.key)
                setAllState(response);
                setState()
                setCity()
                setAllCity([])
            } catch (error) {
                message.error(error)
            }
        } else {
            setAllState([]);
            setAllCity([])
            setState()
            setCity()
        }
    }
    const handleStateChange = async (value, option) => {
        setState(value);
        if (option.key) {
            try {
                const response = await getCityData(option.key)
                setAllCity(response);
                setCity()
            } catch (error) {
                message.error(error)
            }
        }
        else {
            setAllCity([]);
            setCity()
        }
    }
    const handleCityChange = (value) => {
        setCity(value)
    }
    const successMessage = (titles, data, type) => {
        const modal = Modal.success({
            className: "Glitter-MessagePopup",
            title: (
                <div style={{ display: 'flex', alignItems: 'center', gap: 5, justifyContent: "center" }}>
                    {type === "Approve" ? <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} /> : <CheckCircleOutlined style={{ color: 'green', fontSize: 20 }} />}
                    <span>{titles}</span>
                </div>
            ),
            content: <p>{data}</p>,
            centered: true,
            okButtonProps: { style: { display: 'none' } },
            closable: true,
            onCancel: () => modal.destroy(),
        });
    }
    const getUserDetail = async () => {
        if (UrlId === undefined || UrlId === null) {
            if (profile.department === "Sales") {
                form.setFieldsValue({
                    leadOwner: profile.userId
                });
            }
        }
    }
    useEffect(() => {
        if (FromPage) {
            form.setFieldsValue({
                assistantcontactnumber: undefined,
                assistantname: undefined,
                department: undefined,
                description: undefined,
                email: undefined,
                fax: undefined,
                contactSource: undefined,
                firstName: undefined,
                lastName: undefined,
                leadOwner: undefined,
                mobile: undefined,
                phone: undefined,
                postcode: undefined,
                reportingto: undefined,
                street: undefined,
                title: "Mr.",
                country: undefined,
                designation: undefined,
                seniorityLevel: undefined,
                linkedinUrl: undefined,
            })
            setExpectedClosureDate(null)
            setFileList([])
            setImage()
            setDeleteOpen(false)
            setChecked(false)
            setDrawerPage()
            setCountry()
            setState()
            setCity()
            getUserDetail()
            setDisplayData("Create")
            setContactInitial(InitialData.ContactData)
            setEdit(true)
            setEditField(true)
        }
    }, [UrlId, FromPage]);
    const fetchAll = async () => {
        await Promise.allSettled([
            getCountry(),
            UserDetailsApi(),
            getContactsource(),
        ])
        setUiReady(true)
    };
    useEffect(() => {
        if (FromPage && editField) {
            fetchAll()
        }
    }, [FromPage, editField])
    useEffect(() => {
        if (FromPage) {
            if (FromPage === "AccountPage") {
                form.setFieldsValue({
                    accountName: dataForDeal?.AccountId
                })
            }
        }
    }, [FromPage])
    useEffect(() => {
        if (FromPage) {
            AccountApi()
        }
    }, [displayData, FromPage])
    const CloseDrawer = () => {
        setCancelConfirmOpen(false)
        form.setFieldsValue({
            assistantcontactnumber: null,
            accountName: null,
            assistantname: null,
            department: null,
            description: null,
            email: null,
            fax: null,
            contactSource: null,
            firstName: null,
            lastName: null,
            leadOwner: null,
            mobile: null,
            phone: null,
            postcode: null,
            reportingto: null,
            street: null,
            title: null,
            country: null,
            designation: null,
            seniorityLevel: null,
            linkedinUrl: null,
        })
        setExpectedClosureDate(null)
        setFileList([])
        setImage()
        setDeleteOpen(false)
        setChecked(false)
        setStates({
            ...states,
            selectedRowKeys: []
        });
        setDrawerPage()
        setCountry()
        setState()
        setCity()
        if (FromPage !== "EntityUpdate" && FromPage !== "AccountPage") {
            GetAll();
        }
        if (FromPage !== "EntityUpdate") {
            setCratePage();
        }
        setEdit(false);
        setEditField(false);
        dispatch(setEditCall(false))
        setUiReady(false)
    }
    const onSubmit = async (values) => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDoubleClick(true)
        let hideMessage;
        const {
            assistantcontactnumber,
            accountName, seniorityLevel,
            assistantname,
            department,
            description,
            email,
            fax,
            linkedinUrl,
            contactSource,
            firstName,
            lastName,
            leadOwner,
            mobile,
            phone,
            postcode,
            reportingto,
            street,
            title
        } = values;
        const payload =
        {
            seniorityLevelId: normalizeValue(seniorityLevel),
            firstName: normalizeValue(firstName),
            lastName: normalizeValue(lastName),
            leadOwner: normalizeValue(leadOwner),
            accountId: normalizeValue(accountName),
            title: normalizeValue(title),
            reportingTo: normalizeValue(reportingto),
            assitantName: normalizeValue(assistantname),
            department: normalizeValue(department),
            email: normalizeValue(email),
            phone: normalizeValue(phone),
            fax: normalizeValue(fax),
            designation: normalizeValue(expectedClosureDate),
            mobile: normalizeValue(mobile),
            contactSourceId: normalizeValue(contactSource),
            contactFiles: FILEList,
            contactProfile: normalizeValue(image),
            assitantContactNumber: normalizeValue(assistantcontactnumber),
            emailOtpOut: normalizeValue(checked),
            description: normalizeValue(description),
            city: normalizeValue(city),
            street: normalizeValue(street),
            country: normalizeValue(country),
            postcode: normalizeValue((postcode && postcode !== "") ? Number(postcode) : undefined),
            state: normalizeValue(state),
            linkedinUrl: normalizeValue(linkedinUrl)
        }
        const updatedFields = getChangedFields(payload, contactInitial);
        if (Object.keys(updatedFields).length === 0) {
            message.success("Resident updated")
            setEdit(false)
            dispatch(setEditCall(false));
            setEditField(false)
            CloseDrawer()
            loadingRef.current = false;
            setDoubleClick(false)
            return;
        }
        try {
            hideMessage = message.loading("Loading...", 0);
            if (FromPage !== "EntityUpdate") {
                const response = await createContacts(updatedFields)
                if (response.status === 201) {
                    const isAutomation = response?.data === AutomationMessage;
                    const isApproval = response?.data === ApprovalMessage;
                    dispatch(setEditCall(false))
                    setEdit(!edit)
                    setEditField(false)
                    loadingRef.current = false;
                    setDoubleClick(false)
                    hideMessage();
                    if (isApproval) {
                        successMessage("Your action has triggered an approval process", "This record is now in the approval queue, and further changes are restricted until the approval process is complete", "Approve");
                        setTimeout(() => {
                            CloseDrawer();
                        }, 1000);
                    } else if (isAutomation) {
                        successMessage("Automation rule triggered", response?.data);
                        setTimeout(() => {
                            CloseDrawer();
                        }, 1000);
                    } else {
                        CloseDrawer();
                        message.success(response?.data);
                    }
                    if (FromPage === "AccountPage") {
                        CallBackTrigger("Callback")
                    }
                }
            }
        }
        catch (error) {
            hideMessage();
            loadingRef.current = false;
            setDoubleClick(false)
            message.error(error)
        }
    }
    const PageCancel1 = () => {
        setCancelConfirmOpen(true)
    }
    const RequiredDateFormating = (dateString) => {
        const parsedDate = moment(dateString, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD")
        const formattedDate = parsedDate.format("YYYY-MM-DD");
        return formattedDate;
    }
    const expectedClosureDateChange = (date, dateString) => {
        const formattedDate = RequiredDateFormating(dateString)
        setExpectedClosureDate(formattedDate);
        form.setFieldsValue({ designation: date });
    };
    return (
        <>
            <Drawer
                className='Drawer-Header-Pages'
                bodyStyle={{ padding: 0 }}
                title={
                    FromPage === "EntityUpdate" ?
                        drawerPage === "CloneLead" ? "Clone Resident" :
                            <span>
                                Update Resident
                                {(displayData?.first_name || displayData?.last_name) && (
                                    <>
                                        <span style={{
                                            margin: '0 10px',
                                            color: '#d9d9d9',
                                            fontWeight: 'normal'
                                        }}>|</span>
                                        <span style={{ fontWeight: 'normal' }}>
                                            {`${displayData?.first_name || ''} ${displayData?.last_name || ''}`.trim()}
                                        </span>
                                    </>
                                )}
                            </span>
                        : "Create Resident"
                }
                closable={false}
                placement="right"
                open={editField}
                width="80%"
                extra={
                    <Space>
                        <div className='Hover-Refresh2 back-hover1 able-style'
                            role="button"
                            tabIndex={0} title='Close'
                            onClick={() => PageCancel1()}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    PageCancel1()
                                }
                            }}
                            aria-label='Close'
                        > <CancelIcon width={24} height={24} /></div>
                    </Space>
                }
                footer={uiReady ? [
                    <div className="form_action_button">
                        <Button
                            className="gray-button" size="small"
                            onClick={() => PageCancel1()}
                        >
                            <CancelIcon height={25} width={25} />Cancel
                        </Button>
                        <Button size="small" htmlType="submit" className="button_colors" onClick={() => form.submit()} disabled={doubleClick} loading={doubleClick}>
                            {!doubleClick && <SaveIcon height={25} width={25} />}{FromPage === "EntityUpdate" && drawerPage !== "CloneLead" ? "Update" : "Save"}
                        </Button>
                    </div>] : false
                }
            >
                {uiReady ? <Scrollbars autoHide autoHideTimeout={500} autoHideDuration={200}>
                    <AddUser>
                        <div className="user-info-form">
                            {/* <AddProductForm> */}
                            <Form style={{ width: '100%' }} form={form} name="info" onFinish={onSubmit} onFinishFailed={onFinishFailed} colon={false}>
                                <BasicFormWrapper>
                                    <div className="add-product-block">
                                        <div style={{ margin: 40 }}>
                                            <Row gutter={15}>
                                                <Col xs={24}>
                                                    <div className="add-product-content">
                                                        <Heading as="h5">Basic Information</Heading>
                                                        <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="First Name" name="firstName" id="firstName" rules={[{ required: true, message: 'Please enter first name' }, {
                                                                    validator: (_, value) => {
                                                                        const error = nameOnChangeValidator(value, 25);
                                                                        if (error) {
                                                                            return Promise.reject(new Error(error));
                                                                        }
                                                                        return Promise.resolve();
                                                                    },
                                                                }]}>
                                                                    <Input placeholder="Enter First Name" />
                                                                </Form.Item>
                                                            </Col>

                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Last Name" name="lastName" id="lastName"
                                                                    rules={[{ required: true, message: 'Please enter last name' }, {
                                                                        validator: (_, value) => {
                                                                            const error = nameOnChangeValidator(value, 25);
                                                                            if (error) {
                                                                                return Promise.reject(new Error(error));
                                                                            }
                                                                            return Promise.resolve();
                                                                        },
                                                                    }]}>
                                                                    <Input placeholder="Enter Last Name" />
                                                                </Form.Item>
                                                            </Col>

                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Date of Birth" name="designation"
                                                                    id="designation"
                                                                    rules={[{ required: true, message: 'Please select date of birth', }
                                                                    ]}>
                                                                    <Input placeholder="Enter Date of Birth" />
                                                                </Form.Item>
                                                            </Col>

                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Email Address" name="email"
                                                                    id="email" rules={[{ required: true, message: 'Please enter email' }, {
                                                                        validator: (_, value) => {
                                                                            const error = validateEmailField(value, 50);
                                                                            if (error) {
                                                                                return Promise.reject(new Error(error));
                                                                            }
                                                                            return Promise.resolve();
                                                                        },
                                                                    }]} >
                                                                    <Input placeholder="Enter Email Address" />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Name and Relationship (next of Kin)" name="mobile"
                                                                    id="mobile"
                                                                // rules={
                                                                //     [
                                                                //         {
                                                                //             validator: (_, value) => {
                                                                //                 const error = mobileOnChangeValidator(value, 20);
                                                                //                 if (error) {
                                                                //                     return Promise.reject(new Error(error));
                                                                //                 }
                                                                //                 return Promise.resolve();
                                                                //             },
                                                                //         },
                                                                //     ]
                                                                // }
                                                                >
                                                                   <DatePicker
                                                                                                                                           format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                                                                                                                           value={expectedClosureDate ? moment(expectedClosureDate, "YYYY-MM-DD") : null}
                                                                                                                                           onChange={expectedClosureDateChange}
                                                                                                                                           disabledDate={(current) => {
                                                                                                                                               return current && current > moment().endOf("day");
                                                                                                                                           }}
                                                                                                                                       />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Phone Number (Next of Kin)" name="phone"
                                                                    id="phone" rules={[
                                                                        {
                                                                            validator: (_, value) => {
                                                                                const error = mobileOnChangeValidator(value, 20);
                                                                                if (error) {
                                                                                    return Promise.reject(new Error(error));
                                                                                }
                                                                                return Promise.resolve();
                                                                            },
                                                                        },
                                                                    ]}>
                                                                    <Input placeholder="Enter Phone Number" />
                                                                </Form.Item>
                                                            </Col>

                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="NHS Number" name="fax"
                                                                    id="fax" rules={
                                                                        [
                                                                            {
                                                                                validator: (_, value) => {
                                                                                    const error = mobileOnChangeValidator(value, 20);
                                                                                    if (error) {
                                                                                        return Promise.reject(new Error(error));
                                                                                    }
                                                                                    return Promise.resolve();
                                                                                },
                                                                            },
                                                                        ]
                                                                    }>
                                                                    <Input placeholder="Enter Fax Number" />
                                                                </Form.Item>
                                                            </Col>
                                                        </Row>
                                                        <Heading as="h5">Resident Information</Heading>
                                                        <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Resident Owner" name="leadOwner"
                                                                    id="leadOwner" rules={[{ required: true, message: 'Please select a resident owner', }]}>
                                                                    <Select style={{ width: '100%' }}
                                                                        placeholder="Select Resident Owner"
                                                                        showSearch
                                                                        optionLabelProp="label"
                                                                        filterOption={(input, option) => {
                                                                            const usernameElement = option.children.props.children[1].props.children[0];
                                                                            if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                const username = String(usernameElement.props.children);
                                                                                return username.toLowerCase().includes(input.toLowerCase());
                                                                            }
                                                                            return false;
                                                                        }
                                                                        }
                                                                    >
                                                                        {users}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>

                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Sponsor Name" name="accountName"
                                                                    id="accountName" rules={[{ required: true, message: 'Please select sponsor name', }]}>
                                                                    <Select style={{ width: '100%' }}
                                                                        placeholder="Select Sponsor Name"
                                                                        showSearch optionLabelProp="label"
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) => {
                                                                            const usernameElement = option.children.props.children[1].props.children[0];
                                                                            if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                const username = String(usernameElement.props.children);
                                                                                return username.toLowerCase().includes(input.toLowerCase());
                                                                            }
                                                                            return false;
                                                                        }
                                                                        }>
                                                                        {account.filter((item) => item.account_type_name === "Customer").map((option, i) => (
                                                                            <Option value={option.account_id} key={i} label={(
                                                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                                    <div className='Div_flex2'>
                                                                                        <div className='share_image' title={`${option.account_name} (${option.account_number})`} style={{ cursor: "default" }}>
                                                                                            {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                                                                                < img src={option.account_profile} alt="profile" />
                                                                                                :
                                                                                                <span className="image_icon AccountIcon">
                                                                                                    {option.account_name.slice(0, 1).toUpperCase()}
                                                                                                </span>
                                                                                            }
                                                                                            <span className='div-ellipsis'>{option.account_name}</span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>)}>
                                                                                <div className='UserList-dropdown' title={`${option.account_name} (${option.account_number})`}>
                                                                                    <div>
                                                                                        {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                                                                            < img src={option.account_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                                                                            :
                                                                                            <span className='details_span_Tag AccountIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                                {option.account_name.slice(0, 1).toUpperCase()}
                                                                                            </span>
                                                                                        }</div>
                                                                                    <div>
                                                                                        <p style={{ fontWeight: 'bold', margin: 0 }}>{option.account_name}</p>
                                                                                        <p style={{ margin: 0 }}>{option.account_number}</p>
                                                                                    </div>
                                                                                </div>
                                                                            </Option>))}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>

                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Sponsor Url" name="department"
                                                                    id="department" rules={[
                                                                        // { required: true, message: 'Please enter department' },
                                                                        {
                                                                            validator: (_, value) => {
                                                                                const error = validateUrlField(value, 2000);
                                                                                if (error) {
                                                                                    return Promise.reject(new Error(error));
                                                                                }
                                                                                return Promise.resolve();
                                                                            },
                                                                        },
                                                                    ]}>
                                                                    <Input placeholder="Enter Sponsor Url" />
                                                                </Form.Item>
                                                            </Col>

                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Referrer Name & Role" name="assistantname"
                                                                    id="assistantname"
                                                                // rules={[{
                                                                //     validator: (_, value) => {
                                                                //         const error = nameOnChangeValidator(value, 50);
                                                                //         if (error) {
                                                                //             return Promise.reject(new Error(error));
                                                                //         }
                                                                //         return Promise.resolve();
                                                                //     },
                                                                // }]}
                                                                >
                                                                    <Input placeholder="Enter Referrer Name & Role" />
                                                                </Form.Item>
                                                            </Col>

                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Referral Source" name="assistantcontactnumber"
                                                                    id="assistantcontactnumber">
                                                                    <Select style={{ width: '100%' }}
                                                                        placeholder="Select Referral Source"
                                                                        showSearch allowClear onChange={(value) => form.setFieldsValue({ assistantcontactnumber: value || null })}
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) =>
                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }
                                                                    >
                                                                        <Option value="NHS / ICB">NHS / ICB</Option>
                                                                        <Option value="Local Authority">Local Authority</Option>
                                                                        <Option value="Community Mental Health Team">Community Mental Health Team</Option>
                                                                        <Option value="Hospital / Secure Unit">Hospital / Secure Unit</Option>
                                                                        <Option value="GP">GP</Option>
                                                                        <Option value="Social Worker">Social Worker</Option>
                                                                        <Option value="Self-Referral">Self-Referral</Option>
                                                                        <Option value="Other">Other</Option>
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>

                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Resident Source" name="contactSource"
                                                                    id="contactSource" rules={[{ required: true, message: 'Please select a contact source', }]}>
                                                                    <Select style={{ width: '100%' }} placeholder="Select Resident Source"
                                                                        showSearch
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) =>
                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }>
                                                                        {contactsource}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>

                                                        </Row>
                                                        <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                            <Col span={24} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Primary Diagnosis / Reason for Referral" name="description" id="description" rules={
                                                                    [
                                                                        {
                                                                            validator: (_, value) => {
                                                                                const error = validateDescriptionField(value, 2500);
                                                                                if (error) {
                                                                                    return Promise.reject(new Error(error));
                                                                                }
                                                                                return Promise.resolve();
                                                                            },
                                                                        },
                                                                    ]
                                                                }>
                                                                    <Input.TextArea rows={3} maxLength={2500} showCount placeholder='Enter Description' />
                                                                </Form.Item>
                                                            </Col>
                                                        </Row>
                                                        <Heading as="h5">Address Information</Heading>
                                                        <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Country" name="country" id="country" rules={[{ message: 'Please select country', required: true }]}>
                                                                    <Select
                                                                        style={{ width: '100%' }}
                                                                        showSearch
                                                                        allowClear
                                                                        placeholder="Select Country"
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) =>
                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }
                                                                        onChange={handleCountryChange}
                                                                        value={country}
                                                                    >
                                                                        {allCountry?.map((option) => (
                                                                            <Option key={option.countryId} value={option.country}>
                                                                                {option.country}
                                                                            </Option>
                                                                        ))}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="State" >
                                                                    <Select
                                                                        style={{ width: '100%' }}
                                                                        showSearch
                                                                        allowClear
                                                                        placeholder="Select State"
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) =>
                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }
                                                                        onChange={handleStateChange}
                                                                        value={state}
                                                                    >
                                                                        {allState?.map((option) => (
                                                                            <Option key={option.stateId} value={option.state}>
                                                                                {option.state}
                                                                            </Option>
                                                                        ))}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="City" >
                                                                    <Select
                                                                        style={{ width: '100%' }}
                                                                        showSearch
                                                                        allowClear
                                                                        placeholder="Select City"
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) =>
                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }
                                                                        onChange={handleCityChange}
                                                                        value={city}
                                                                    >
                                                                        {allCity?.map((option) => (
                                                                            <Option key={option.cityId} value={option.city}>
                                                                                {option.city}
                                                                            </Option>
                                                                        ))}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Street name and No" name="street" id="street" rules={[{
                                                                    validator: (_, value) => {
                                                                        const error = validateAddressLine(value, 100);
                                                                        if (error) {
                                                                            return Promise.reject(new Error(error));
                                                                        }
                                                                        return Promise.resolve();
                                                                    },
                                                                }]}>
                                                                    <Input placeholder="Enter Street name and no" />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Zip Code" id="postcode" name="postcode" rules={[{
                                                                    validator: (_, value) => {
                                                                        const error = validateZipCode(value, 25);
                                                                        if (error) {
                                                                            return Promise.reject(new Error(error));
                                                                        }
                                                                        return Promise.resolve();
                                                                    },
                                                                }]}>
                                                                    <Input placeholder="Enter Zip Code" />
                                                                </Form.Item>
                                                            </Col>
                                                        </Row >
                                                        <RelatedDocUpload edit={edit} FILEList={FILEList} setFileList={setFileList} form={form} />
                                                        <Heading as="h5">Profile Picture</Heading>
                                                        <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <figure className="photoUpload align-center-v" >
                                                                    {image !== null && image !== undefined && image !== "" ?
                                                                        < img src={image} alt="" />
                                                                        :
                                                                        UrlId !== undefined && UrlId !== null && UrlId[0] === "?CONTACT" ?
                                                                            <span className='details_span_Tag ContactIcon'>
                                                                                {displayData?.first_name?.slice(0, 1).toUpperCase()}
                                                                            </span>
                                                                            :
                                                                            <span className='details_span_Tag ContactIcon'>
                                                                                C
                                                                            </span>}
                                                                    <figcaption>
                                                                        {deleteOption ? (
                                                                            <div className='delete-div'>
                                                                                <span className='delete-span'>
                                                                                    <FeatherIcon icon="trash-2" className="icon-svg" size={16} onClick={handleDeleteImage} />
                                                                                </span>
                                                                            </div>) :
                                                                            (<div><ImgCrop aspect={1} cropShape="round" rotationSlider modalTitle="Crop Image">
                                                                                <Upload {...FileUpload}>
                                                                                    <Link className="btn-upload" to={combinedUrl}>
                                                                                        <FeatherIcon icon="camera" size={16} />
                                                                                    </Link>
                                                                                </Upload></ImgCrop>
                                                                            </div>)
                                                                        }
                                                                    </figcaption>
                                                                </figure>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </BasicFormWrapper>
                            </Form>
                            {/* </AddProductForm> */}
                        </div>
                    </AddUser>
                </Scrollbars> :
                    <div className="spin">
                        <Spin />
                    </div>}
            </Drawer>
            {cancelConfirmOpen && <AllCancelPopup confirmPopup={cancelConfirmOpen} setConfirmPopup={setCancelConfirmOpen} GetCallback={CloseDrawer} />}
        </>
    );
}

AddNew.propTypes = {
    UrlId: PropTypes.array.isRequired,
    FromPage: PropTypes.string.isRequired,
    setCratePage: PropTypes.func.isRequired,
    GetAll: PropTypes.func.isRequired,
    dataForDeal: PropTypes.object.isRequired,
    CallBackTrigger: PropTypes.func.isRequired,
};
export default AddNew;